//export const BACKEND_URL = "https://localhost:44392/api/be/"; // -> //localhost (DA ATTIVARE IN TESTING)
//export const BACKEND_URL = "http://192.168.1.124:58680/api/be/"; //-> non va
export const BACKEND_URL_PAY = "https://localhost:44392/api/pay/"; // ORIG
//export const BACKEND_URL_PAY = "https://backend.idabooking.eu/api/pay/"; // -> attualmente non in uso (get your cash)
export const BACKEND_URL = "https://backend.idabooking.eu/api/be/"; // -> prod?   //production (credit card) (DA ATTIVARE IN PRODUCTION)
